// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpcomingRouteImport } from './routes/upcoming'
import { Route as TodayRouteImport } from './routes/today'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as EntitiesRouteImport } from './routes/entities'
import { Route as ListsRouteRouteImport } from './routes/lists/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NotesNoteIdRouteImport } from './routes/notes/$noteId'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as ListsIndexRouteImport } from './routes/lists/index'
import { Route as ListsNewRouteImport } from './routes/lists/new'
import { Route as ListsListIdRouteImport } from './routes/lists/$listId'

const UpcomingRoute = UpcomingRouteImport.update({
            id: '/upcoming',path: '/upcoming',getParentRoute: () => rootRouteImport
          })
const TodayRoute = TodayRouteImport.update({
            id: '/today',path: '/today',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const InboxRoute = InboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => rootRouteImport
          })
const EntitiesRoute = EntitiesRouteImport.update({
            id: '/entities',path: '/entities',getParentRoute: () => rootRouteImport
          })
const ListsRouteRoute = ListsRouteRouteImport.update({
            id: '/lists',path: '/lists',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const NotesNoteIdRoute = NotesNoteIdRouteImport.update({
            id: '/notes/$noteId',path: '/notes/$noteId',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const ListsIndexRoute = ListsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ListsRouteRoute
          })
const ListsNewRoute = ListsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => ListsRouteRoute
          })
const ListsListIdRoute = ListsListIdRouteImport.update({
            id: '/$listId',path: '/$listId',getParentRoute: () => ListsRouteRoute
          })





const ListsRouteRouteChildren = {
  ListsListIdRoute: ListsListIdRoute,ListsNewRoute: ListsNewRoute,ListsIndexRoute: ListsIndexRoute
}

const ListsRouteRouteWithChildren = ListsRouteRoute._addFileChildren(ListsRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ListsRouteRoute: ListsRouteRouteWithChildren,EntitiesRoute: EntitiesRoute,InboxRoute: InboxRoute,SettingsRoute: SettingsRoute,TodayRoute: TodayRoute,UpcomingRoute: UpcomingRoute,AuthCallbackRoute: AuthCallbackRoute,NotesNoteIdRoute: NotesNoteIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)